<script>
import 'animate.css'
import { WOW } from 'wowjs'
export default {
  data() {
    return {
      list1: [
        {
          icon: '<i class="icomoon icon-customer"></i>',
          title: '客戶管理',
          content: '客戶和寵物服務紀錄都一次到位，隨時調閱、以寵物狀況調整服務，建立良好客戶關係！'
        },
        {
          icon: '<i class="icomoon icon-people"></i>',
          title: '服務人員管理',
          content: '設定每位員工可提供什麼類型的服務，清楚紀錄接待過的寵物和服務'
        },
        {
          icon: '<i class="icomoon icon-coupon"></i>',
          title: '優惠券',
          content: '依照行銷活動提供優惠折扣碼，吸引更多客戶上門！'
        },
        {
          icon: '<i class="icomoon icon-service"></i>',
          title: '服務＆加購設定',
          content: '區分一般服務和加購項目。可依據寵物當日的狀況推薦現場加購，讓服務內容更有彈性！'
        },
        
      ],
      list2: [
        {
          icon: '<i class="icomoon icon-shop"></i>',
          title: '分店管理',
          content: '多家分店可各自設定店家資訊，讓您的客戶快速選擇他們最便利的分店！'
        },
        {
          icon: '<i class="icomoon icon-text"></i>',
          title: '簡訊通知',
          content: '減少客戶缺席狀況！自動發送預約通知，免除繁複又艱苦的聯繫提醒，每天至少可幫您節省2小時'
        },
        {
          icon: '<i class="icomoon icon-messenger"></i>',
          title: `Line 官方帳號預約`,
          content: '客戶可以輕鬆透過 Line 預約服務，也能輕鬆查詢包月、儲值狀態。'
        },
      ]
    }
  },
  mounted() { 
    this.$nextTick(() => {  
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<template>
  <div :class="$style.sectionList" class="section">
    <div class="container">
      <BaseSectionTitle 
        title="整合您所需要的一切功能" 
        sub-title="Functions" 
        class="isStyleDecoration text-center isCenter mx-auto wow animate__animated animate__fadeInUp"
      />
      <div class="row justify-content-center sectionList__list item1 wow animate__animated animate__fadeInUp">
        <div
          v-for="(item, $index) in list1"
          :key="$index"
          class="col-lg-3 col-6 sectionList__item"
        >
         <BaseList :title="item.title" :icon="item.icon" :content="item.content"/>
        </div>
      </div>
      <div class="row justify-content-center sectionList__list wow animate__animated animate__fadeInUp">
        <div
          v-for="(item2, $index2) in list2"
          :key="$index2"
          class="col-lg-3 col-6 sectionList__item"
        >
         <BaseList :title="item2.title" :icon="item2.icon" :content="item2.content"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .sectionList {
    position: relative;
    &:before {
      content:'';
      position: absolute;
      bottom:-15%;
      background-image: url('@assets/images/home/section3-bg.svg');
      padding-bottom: 39%;
      background-repeat: no-repeat;
      background-size: cover;      
      width: 100vw;
      left: 0;
      @include max-lg {
        bottom: -12%;
        background-position: 10%;
      }
      @include max-md {
        bottom: -9%;
        background-position: 25%;
      }
      @include max-xl {
        padding-bottom: 0;
        height: 100%;
      }
    }
    &:after {
      content:'';
      position: absolute;
      background-image: url('@assets/images/home/section3-paw.svg');
      background-repeat: no-repeat;
      background-size: cover;
      width: 205px;
      height: 265px;
      bottom: -20%;
      left: 0;
      @include max-lg {
        display: none;
      }
    }
    :global {
      .row {
        @include max-lg {
          margin-left: -9px;
          margin-right: -9px;
        }
      }
      [class*="col-"] {
        @include max-lg {
          padding-left: 9px;
          padding-right: 9px;
        }
      }
      .sectionList {
        &__list {
         &item1 {
            margin-top: -20px;
         }
        }
        &__item {
          margin-top: 60px;
        }
      }
    }
  }
</style>